import { FormField } from "@ui/components/Form";
import { InputIcon } from "@ui/components/Inputs/components";
import { TextInput } from "@ui/components/Inputs/TextInput/TextInput";
import { useTranslations } from "@ui/providers/useTranslations";

import { MailClassicIcon } from "@jti/brand-icons/mail-classic";

import styles from "./EmailInput.module.scss";

export type EmailInputProps = {
  placeholder?: string;
};

export const EmailInput = ({ placeholder }: EmailInputProps) => {
  const { __ } = useTranslations();

  return (
    <div className={styles.emailInputContainer}>
      <FormField
        name="email"
        className={styles.custom}
        showCustomError
        validation={{
          required: "Field is required",
          validate: {
            emailValid: (value) => /\S+@\S+\.\S+/.test(value) || "Invalid email",
          },
        }}
        render={({ field, fieldState }) => (
          <TextInput
            {...field}
            elemBefore={<InputIcon icon={MailClassicIcon} />}
            placeholder={placeholder}
            aria-label={__("subscribe_form.email")}
            containerClassName={styles.container}
            isError={fieldState.invalid}
            errorText={fieldState.error?.message || ""}
          />
        )}
      />
    </div>
  );
};
